<template>
  <div :id="mapId"></div>
</template>

<script>
export default {
  props: {
    longitude: String,
    latitude: String,
  },
  data() {
    return {
      map: null,
      mapId:
        "map_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9),
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 确保 DOM 已渲染
      this.$nextTick(() => {
        try {
          // 使用天地图原生 JavaScript API
          if (typeof window.T !== "undefined") {
            this.createMap();
          } else {
            // 动态加载天地图 API
            this.loadTiandituAPI()
              .then(() => {
                this.createMap();
              })
              .catch((error) => {
                console.error("地图加载失败:", error);
              });
          }
        } catch (error) {
          console.error("地图初始化失败:", error);
        }
      });
    },
    loadTiandituAPI() {
      return new Promise((resolve, reject) => {
        // 如果已经加载过，直接返回
        if (typeof window.T !== "undefined") {
          resolve();
          return;
        }

        // 检查是否正在加载
        if (window._tiandituLoading) {
          window._tiandituLoading.then(resolve).catch(reject);
          return;
        }

        // 创建加载 Promise
        window._tiandituLoading = new Promise((res, rej) => {
          // 天地图 key 配置
          // 方式1：直接在这里配置（推荐用于快速测试）
          // 方式2：使用环境变量 TIANDITU_KEY
          // 申请地址：https://lbs.tianditu.gov.cn/server/MapService.html
          const tiandituKey =
            process.env.TIANDITU_KEY || "81cdd6420190bffb2ff9900dab3de2b8";

          // 加载天地图 JavaScript API
          const script = document.createElement("script");
          script.type = "text/javascript";
          script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${tiandituKey}`;
          script.async = true;

          script.onload = () => {
            // 等待 T 对象初始化
            const checkT = setInterval(() => {
              if (typeof window.T !== "undefined") {
                clearInterval(checkT);
                window._tiandituLoading = null;
                res();
              }
            }, 50);

            // 超时处理（10秒）
            setTimeout(() => {
              clearInterval(checkT);
              if (typeof window.T === "undefined") {
                window._tiandituLoading = null;
                rej(new Error("天地图 API 加载超时"));
              }
            }, 10000);
          };

          script.onerror = () => {
            window._tiandituLoading = null;
            rej(new Error("天地图 API 加载失败"));
          };

          document.head.appendChild(script);
        });

        window._tiandituLoading.then(resolve).catch(reject);
      });
    },
    createMap() {
      const lng = parseFloat(this.longitude) || 113.23333;
      const lat = parseFloat(this.latitude) || 23.16667;

      // 创建地图实例，使用经纬度投影（EPSG:4326）
      this.map = new window.T.Map(this.mapId, {
        projection: "EPSG:4326", // 使用经纬度投影
      });

      // 设置地图中心点和缩放级别
      this.map.centerAndZoom(new window.T.LngLat(lng, lat), 16);

      // 添加天地图矢量底图图层
      const vecLayer = new window.T.TileLayer(
        "http://t{s}.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=81cdd6420190bffb2ff9900dab3de2b8",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
          attribution: "&copy; 国家基础地理信息中心",
        }
      );
      this.map.addLayer(vecLayer);

      // 添加天地图矢量标注图层（中文标注）
      const cvaLayer = new window.T.TileLayer(
        "http://t{s}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=81cdd6420190bffb2ff9900dab3de2b8",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
          attribution: "&copy; 国家基础地理信息中心",
        }
      );
      this.map.addLayer(cvaLayer);

      // 添加标记点
      const marker = new window.T.Marker(new window.T.LngLat(lng, lat));
      this.map.addOverLay(marker);
    },
  },
  beforeDestroy() {
    // 清理地图实例
    if (this.map) {
      this.map = null;
    }
  },
};
</script>

<style lang="scss" scoped>
div[id^="map_"] {
  height: 174px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/map/index.vue